import React from 'react';
import { C44TestimonialCardProps } from './C44TestimonialCard.types';
import { GetTestimonialCardModel } from './C44TestimonialCard.service';
import { TestimonialCard } from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C44TestimonialCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  const model = GetTestimonialCardModel(props?.fields);

  return <TestimonialCard {...model} data-component={marketingRenderingName} />;
};
